import React, { useState, useEffect } from 'react';
import { Button, Grid, Paper, useMediaQuery } from '@mui/material';
import { format_date, getCurrentDate } from '../../Utils/Dateutils';
import styled, { inputStyles } from '../../Utils/inputChanges';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectJobworkPaymentData, selectPaymentMemo, selectPrevBalEmpAmt } from '../Selectors/JobworkSelector/JobworkSelect';
import { fetchJobworkPaymentData } from '../../Store/PHPSlice/Jobwork/jobworkApi';
import Dropdown from '../FieldsComponents/Dropdown';
import TextareaComponent from '../FieldsComponents/TextareaComponent';
import { fetchPaymentMemo, fetchPrevBalanceEmpAmt, insertPaymentEntry } from '../../Store/PHPSlice/Payment/paymentApi';


const PaymentEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        jobId: Id,
        dt: getCurrentDate(),
        fdt: '',
        tdt: '',
        empId: '',
        empNm: '',
        payMemo: '',
        netamt: '',
        dedamt: '',
        clothamt: '',
        payableamt: '',
        paidamt: '',
        remainamt: '',
        balamt: '',
        paymode: '',
        naration: '',
        bnkNm: '',
        transId: '',
        userId: userdata?.ID
    });
    const dispatch = useDispatch();
    const jobworklist = useSelector(selectJobworkPaymentData);
    const payMemo = useSelector(selectPaymentMemo);
    const prevBal = useSelector(selectPrevBalEmpAmt);

    useEffect(() => {
        dispatch(fetchJobworkPaymentData(Id));
    }, [Id]);
    useEffect(() => {
        dispatch(fetchPaymentMemo());
    }, []);

    useEffect(() => {
        if (jobworklist?.data) {
            const data = jobworklist?.data;
            setFormData(prev => ({
                ...prev,
                fdt: data.fdt,
                tdt: data.tdt,
                empId: data.empId,
                empNm: data.empNm,
                netamt: data.netamt,
                dedamt: data.deamt,
                clothamt: data.clothamt,
                payableamt: data.payableamt,
                paidamt: data.payableamt
            }));
            dispatch(fetchPrevBalanceEmpAmt(data.empId));

        }

    }, [jobworklist]);


    useEffect(() => {
        if (prevBal?.data?.balamt !== null) {
            const value = prevBal?.data?.balamt;
            const sum = parseFloat(value) + parseFloat(formData.payableamt);
            setFormData(prev => ({
                ...prev,
                balamt: value,
                payableamt: sum,
                paidamt: sum
            }));
            // console.log(prevBal?.data)
        }
    }, [prevBal]);
    useEffect(() => {
        if (payMemo?.data?.memo) {
            const jobmemo = payMemo?.data?.memo;
            setFormData(prev => ({
                ...prev,
                payMemo: jobmemo
            }));
        }
    }, [payMemo]);

    const handleDropdownChange = (e, dropdownType) => {
        const { value, name } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        // switch (name) {
        //     case 'departId':
        //         if (value) {
        //             dispatch(fetchDeptEmpJobwork(value));
        //         }
        //         break;
        // }
    };

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let remainAmt = formData.remainamt; // Initialize remainAmt to 0 by default

        if (name === 'paidamt') {
            const paidAmount = parseFloat(value) || 0;  // Parse paid amount
            const payableAmount = parseFloat(formData.payableamt) || 0; // Ensure payableamt is parsed correctly

            remainAmt = payableAmount - paidAmount; // Calculate remaining amount

            if (paidAmount > payableAmount) {
                alert(`Paid amount cannot be greater than ${payableAmount}`);
                return; // Stop execution and prevent updating state
            }

        }

        setFormData({
            ...formData,
            [name]: value.toUpperCase(),
            remainamt: remainAmt
        });
    };

    const isDesktop = useMediaQuery('(min-width:768px)');

    const fields = [
        { label: 'Date', name: 'dt', type: 'date' },
        { label: 'Payment No.', name: 'payMemo', type: 'readOnly' },
        // { label: 'From Date', name: 'fdt', type: 'date' },
        // { label: 'To Date', name: 'tdt', type: 'date' },
        { label: 'Employee', name: 'empNm', type: 'readOnly' },
        { label: 'Net Amt.', name: 'netamt', type: 'readOnly' },
        { label: 'Deduct Amt.', name: 'dedamt', type: 'readOnly' },
        { label: 'Cloth Deduct Amt.', name: 'clothamt', type: 'readOnly' },
        { label: 'Prev. Balance Amt.', name: 'balamt', type: 'readOnly' },
        { label: 'Payable Amt.', name: 'payableamt', type: 'readOnly' },
        { label: 'Paid Amt.', name: 'paidamt' },
        { label: 'Remaining Amt.', name: 'remainamt', type: 'readOnly', instruct: 'Owner Give Amount' }
    ];

    const fields2 = {
        'Cheque': {
            label: 'Transaction ID.',
            name: 'transId'
        },
        'NEFT': {
            label: 'Transaction ID.',
            name: 'transId'
        },
        'IMPS': {
            label: 'Transaction ID.',
            name: 'transId'
        },
        'RTGS': {
            label: 'Transaction ID.',
            name: 'transId'
        }
    };

    const fields3 = fields2[formData.paymode];

    const fields4 = {
        'Cheque': {
            label: 'Bank Name',
            name: 'bnkNm'
        }
    };
    const fields5 = fields4[formData.paymode];

    const paymodelist = [
        { label: 'Cash', value: 'Cash' },
        { label: 'Cheque', value: 'Cheque' },
        { label: 'NEFT', value: 'NEFT' },
        { label: 'IMPS', value: 'IMPS' },
        { label: 'RTGS', value: 'RTGS' }
    ];

    const dropdownlistfirst = [
        {
            label: 'Payment Mode',
            id: 'paymode',
            options: paymodelist || [],
            value: formData.paymode,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'paymode', value: newValue ? newValue.value : '' } }, 'paymode'),
            getOptionLabel: (option) => option.label || '',
            isOptionEqualToValue: (option, value) => option.value === value.value,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.value === value) || null;
                }
                return null;
            },
        }
    ];

    const naration = {
        label: 'Naration',
        name: 'naration',
        onchange: handleInputChange,
        isDesktop: true
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // const finaldata = postObj(formData, jobwork, extraAmt);
        // console.log(formData);
        dispatch(insertPaymentEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Material Added");
                alert("Record Added");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <h3 className='centered-heading'>Payment Entry</h3>

                    <Grid item xs={12}>
                        <span>From Date: {formData.fdt}</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <span>To Date: {formData.tdt}</span>
                    </Grid>

                    <Grid container spacing={1.2}>
                        {fields.map((field) => (
                            <DateInputComponent
                                key={field.name}
                                formData={formData}
                                handleDateChange={handleDateChange}
                                handleInputChange={handleInputChange}
                                styled={styled}
                                inputStyles={inputStyles}
                                isDesktop={isDesktop}
                                field={field}
                                instruct={field.instruct}
                            />
                        ))}

                        {
                            dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                <Dropdown
                                    key={drop.label}
                                    label={drop.label}
                                    id={drop.id}
                                    options={drop.options}
                                    value={drop.value}
                                    onChange={drop.onChange}
                                    isDesktop={isDesktop}
                                    getOptionLabel={drop.getOptionLabel}
                                    isOptionEqualToValue={drop.isOptionEqualToValue}
                                    valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                />
                            ))
                        }


                        {
                            naration &&
                            <TextareaComponent
                                label={naration.label}
                                name={naration.name}
                                value={formData[naration.name]}
                                onChange={naration.onchange}
                                isDesktop={naration.isDesktop}
                            />
                        }

                        {
                            fields3 &&
                            <DateInputComponent
                                formData={formData}
                                handleDateChange={handleDateChange}
                                handleInputChange={handleInputChange}
                                styled={styled}
                                inputStyles={inputStyles}
                                isDesktop={isDesktop}
                                field={fields3}
                            />
                        }

                        {
                            fields5 &&
                            <DateInputComponent
                                formData={formData}
                                handleDateChange={handleDateChange}
                                handleInputChange={handleInputChange}
                                styled={styled}
                                inputStyles={inputStyles}
                                isDesktop={isDesktop}
                                field={fields5}
                            />

                        }

                        <Grid item xs={12} textAlign="center">
                            <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </>
    );
}

export default PaymentEntry;
